/**
 *
 * Landing Page constants
 *
 */

export const LANDING_PAGE_KEY = 'landing-page';

export const GET_DATA = `mlb/${LANDING_PAGE_KEY}/GET_DATA`;
